import { __css, mergeClasses, Spinner } from '@fluentui/react-components';
import { useCallback, useMemo, useState } from 'react';

import ClipBoard from './components/ClipBoard';
import { ErrorPage } from './components/ErrorPage';
import { FinishedPage } from './components/FinishedPage';
import InfoPopup from './components/InfoPopup';
import StreamView from './components/StreamView';
import type { StreamMessage } from './components/VideoStream';
import { useMediaQuery } from './hooks/useMediaQuery';
import { useSession } from './hooks/useSession';

const useStyles = __css({"root":{"mc9l5x":"f22iagw","Bqenvij":"fyg812x","Beiy3e4":"f1vx9l62"},"content":{"mc9l5x":"f22iagw","Bh6795r":"fqerorx","sshi5w":"fprs0cq","B68tc82":0,"Bmxbyg5":0,"Bpg54ce":"f1a3p1vp","Beiy3e4":"f1063pyq"},"contentVertical":{"Beiy3e4":"f1vx9l62"},"centered":{"mc9l5x":"f22iagw","Brf1p80":"f4d9j23","Bt984gj":"f122n59","a9b677":"fly5x3f","Bqenvij":"f1l02sjl"}});

const App = () => {
  const styles = useStyles();
  const isCramped = useMediaQuery('(max-width: 1000px)');

  const [infoPopupOpen, setInfoPopupOpen] = useState(true);
  const [clipboardHasChanged, setClipboardHasChanged] = useState(false);
  const {
    session,
    loading: sessionLoading,
    error: sessionError,
    endSession,
  } = useSession();

  const handleStreamMessage = useCallback((msg: StreamMessage) => {
    if (msg.type === 'clipboard-changed') {
      setClipboardHasChanged(true);
    }
  }, []);

  const { sessionIdParam, finishedParam } = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      sessionIdParam: params.get('sessionID'),
      finishedParam: params.get('finished'),
    };
  }, []);

  if (sessionError) {
    return <ErrorPage message={sessionError} />;
  }

  const resolvingSpinner = (
    <div className={styles.centered}>
      <Spinner label="Resolving session..." />
    </div>
  );

  const content = (() => {
    if (finishedParam === 'true') {
      return <FinishedPage />;
    }

    if (!sessionIdParam) {
      return <FinishedPage />;
    }

    if (sessionLoading || !session) {
      return resolvingSpinner;
    }

    return (
      <>
        <StreamView
          session={session}
          onEndSession={endSession}
          onMessage={handleStreamMessage}
        />
        <ClipBoard
          session={session}
          open={
            session.properties.clipboardTransferIn ||
            session.properties.clipboardTransferOut
          }
          clipboardHasChanged={clipboardHasChanged}
          onClipboardRead={() => setClipboardHasChanged(false)}
          vertical={isCramped}
        />
      </>
    );
  })();

  return (
    <div className={styles.root}>
      <InfoPopup open={infoPopupOpen} onOpenChange={setInfoPopupOpen} />
      <div
        className={mergeClasses(
          styles.content,
          isCramped && styles.contentVertical,
        )}
      >
        {content}
      </div>
    </div>
  );
};

export default App;


import "/usr/local/jenkins/workspace/BI_bi-frontend_2.2.3/src/App.griffel.css";